import React, { useEffect, useState } from 'react';
import {
  FaUser,
  FaMapMarkerAlt,
  FaBookOpen,
  FaBriefcase,
  FaInfoCircle,
  FaTachometerAlt,
  FaBars,
  FaTimes
} from 'react-icons/fa';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import TopNavbar from '../../top-navbar/TopNav';
import '../../top-navbar/topnavBar.css';
import './CandidateSidebar.css';

const CandidateSidebar = ({ isSidebarDisabled }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userEmail, setUserEmail] = useState('');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);


  useEffect(() => {
    const email = localStorage.getItem('user_email');
    if (email) setUserEmail(email);
  }, []);

  const sidebarWidth = '12rem';

  const navItems = [
    { path: 'candidate-dashboard', label: 'Dashboard', icon: <FaTachometerAlt /> },
    { path: 'dashboard', label: 'Instructions', icon: <FaInfoCircle /> },
    { path: 'personal-info', label: 'Personal Details', icon: <FaUser /> },
    { path: 'address-info', label: 'Address Details', icon: <FaMapMarkerAlt /> },
    { path: 'education-info', label: 'Educational Details', icon: <FaBookOpen /> },
    { path: 'employment-info', label: 'Employment Details', icon: <FaBriefcase /> },
    { path: 'declaration' },
  ];

  const handleNavigation = (path, event) => {
    // Prevent navigation if the sidebar is disabled
    if (isSidebarDisabled) {
      event.preventDefault();
      return;
    }
    navigate(`/candidate/${path}`);
  };

  return (
    <div className="candidate-dashboard-container">
      {/* Top Navbar */}
       <TopNavbar />
        {/* Hamburger button for mobile */}
        <button
          className="hamburger-btn"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          {isSidebarOpen ? <FaTimes /> : <FaBars />}
        </button>
     
      {/* Sidebar */}
<aside
  className={`candidate-dashboard-sidebar ${isSidebarOpen ? 'open' : ''}`}
  style={{ width: sidebarWidth }}
>
  {/* Close button inside sidebar */}
  <button
    className="sidebar-close-btn"
    onClick={() => setIsSidebarOpen(false)}
  >
    <FaTimes />
  </button>

  <nav>
    <ul className="candidate-sidebar-menu">
      {navItems.map((item, index) => (
        <React.Fragment key={item.path}>
          <li
                  className={`candidate-sidebar-menu-item ${isSidebarDisabled ? 'disabled' : ''} ${location.pathname.includes(item.path) ? 'active' : ''}`}
                  onClick={(e) => handleNavigation(item.path, e)}
                >
            <span className="candidate-sidebar-icon">{item.icon}</span>
            <span>{item.label}</span>
          </li>
          {index < navItems.length - 1 && (
            <div className="candidate-sidebar-divider"></div>
          )}
        </React.Fragment>
      ))}
    </ul>
  </nav>
</aside>



      <main className="candidate-dashboard-main">
        <div className="candidate-dashboard-header-row">
          <div className="candidate-dashboard-title-bar">
            {/* The page title can be dynamically rendered here if needed */}
          </div>
        </div>

        <div className="candidate-dashboard-page-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default CandidateSidebar;